import { Unit } from "./TaxonomyElement";
import { SupplierDeliveryTime } from "./SupplierDeliveryTime";
import { LocationAddress } from "./LocationAddress";
import { ContactPersonData } from "./ContactPersonData";
import { ProductProperty } from "./ProductProperty";

export type OrderResolverResolution = 1 | 2 | 3 | 4

export type OrderResolverResult = {
    delivery: Delivery | null,
    resolution: OrderResolverResolution
    missingProducts: MissingProduct[]
}

export type MissingProduct = {
    catalogueProductId: string,
    name: string,
    selectedProperties: ProductProperty[],
    productCode: string
}

export type Delivery = {
    supplier: Supplier,
    items: QuotedProduct[],
    generated: string,
    minimalOrderPrice: number,
    smallOrderFee: number,
    finalPrice: number,
    askingPrice: number,
    basePrice: number,
    currency: string,
    plannedDeliveryStart: string,
    plannedDeliveryEnd: string
}

export type Supplier = {  
    id?: number,
    name: string,
    deliveryTimes?: SupplierDeliveryTime[],
    useExternalSystem: boolean,
    stripeConnectionStatus?: StripeConnectionStatus
} & LocationAddress & ContactPersonData

export type QuotedProduct = {
    catalogueProductId: string,
    supplierProductId: string,
    supplierBoxingId: string,
    quantity: number,
    unit: Unit,
    price?: number,
    pricePerUnit?: number,
    name: string,
    selectedProperties: ProductProperty[]
}

export enum StripeConnectionStatus{
    NotConnected = 1,
    FullyOperable = 2,
    PendingVerification = 3,
    ActionRequired = 4,
    Unknown = 5,
}